@if (displayVoidCreditAction()) {
    <a
        (click)="voidCredit()"
        (keyup.enter)="voidCredit()"
        tabindex="0"
        class="text-primary-800 cursor-pointer"
    >
        Void/Credit
    </a>
}
@if (displayConfirmPaymentAction()) {
    <a
        (click)="confirmPayment()"
        (keyup.enter)="confirmPayment()"
        tabindex="0"
        class="text-primary-800 cursor-pointer"
    >
        Confirm Payment
    </a>
}
@if (displaySendInvoiceAction()) {
    <a
        (click)="sendInvoice()"
        (keyup.enter)="sendInvoice()"
        tabindex="0"
        class="text-primary-800 cursor-pointer"
    >
        @if (invoiceSent) {
            Resend Invoice
        } @else {
            Send Invoice
        }
    </a>
}
